import { SubVocational } from '@lemsar/common/domains/models/sub-vocational';

export class InstitutionBuilding {
    public id: string;
    public institutionId: string;
    public buildingTypeId: string;
    public total: number;
    public capacity: number;
    public area: number;
    public status: string;
    public condition: string;
    public buildingableId: string;
    public buildingableType: string;
    public buildingType: EquipmentCategory;
    public pictures: BuildingPicture[];
    public buildingable: Buildingable;
}

export class EquipmentCategory {
    public id: string;
    public name: string;
}

export class BuildingPicture {
    public id: string;
    public description: string;
    public buildingId: string;
    public bigImage: string;
    public smImage: string;
    public medImage: string;
}

export class Buildingable {
    public subVocational: SubVocational;
    public id: string;
    public subVocationalId: string;
}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/model/buildings.ts